import * as React from 'react';
export const HKSvg = React.forwardRef(function HKSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M7.836 7.915c.22-.749.34-1.212 1.575-1.693 1.235-.482 2.43.792 2.589 1.496-.048.04-.13-.02-.24-.083-.135-.078-.31-.156-.499-.028-.341.23-.414.423-.815.562-.401.138-.754.006-1.11-.293-.355-.299-.943-.46-1.5.04m-.241.392c-.617.478-.987.781-2.27.445-1.282-.337-1.5-2.07-1.214-2.733.142-.012.121.51.532.524.144.005.26-.005.365-.016.197-.02.361-.04.625.041.406.124.615.438.726.888.111.451.492.928 1.236.85m.321.082c.25.738.418 1.187-.318 2.29s-2.446.745-2.979.26c.035-.14.52.05.668-.333.148-.385.097-.585.347-.929.249-.342.613-.437 1.076-.396.462.041 1.037-.163 1.206-.892m.102-.277c.78-.024 1.257-.052 2.097.974.84 1.026-.002 2.556-.623 2.925-.123-.074.201-.484-.123-.737-.324-.254-.53-.264-.786-.603-.256-.338-.24-.714-.065-1.145.174-.43.148-1.04-.5-1.414m-.482-.106c-.638-.45-1.036-.714-1.089-2.04-.053-1.325 1.54-2.04 2.258-1.96.053.133-.452.264-.346.662.106.398.266.53.266.954 0 .424-.239.716-.638.954-.398.239-.744.741-.45 1.43',
      }),
    ),
  );
});
HKSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var HK = {
  category: 'flag',
  colorable: false,
  name: 'HK',
  svg: HKSvg,
};
